export default __webpack_public_path__ + "static/media/TheAmericanDreamCover.8864ac5a.jpeg";